export default __webpack_public_path__ + "static/media/partner-14.bc129bfb.png";